/**
 * Layout Constants
 *
 * Centralized layout dimensions shared across pages.
 * Must stay in sync with App.tsx AppShell configuration.
 */

/**
 * Height of the primary AppShell header in px (must match App.tsx and
 * AdminAppShell header={{ height: 60 }}). Sticky toolbars use this as `top`
 * when scrolling is the viewport — same pattern as EventTypeTabsPanel.
 */
export const APP_HEADER_HEIGHT = 60;
